import request from '@/utils/request'

let SweepstakesApi = {
  /*活动列表*/
  sweepstakesList(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes/index', data, errorback);
  },
  /*添加活动资料*/
  getAddSweepstakes(data, errorback) {
    return request._get('/shop/plus.sweepstakes.sweepstakes/add', data, errorback);
  },
  /*添加活动*/
  addSweepstakes(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes/add', data, errorback);
  },
  /*获取活动数据*/
  editSweepstakes(data, errorback) {
    return request._get('/shop/plus.sweepstakes.sweepstakes/edit', data, errorback);
  },
  /*保存活动*/
  saveSweepstakes(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes/edit', data, errorback);
  },
  /*删除活动*/
  delSweepstakes(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes/delete', data, errorback);
  },
  /*活动抽奖记录列表*/
  sweepstakesRecordList(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes/record', data, errorback);
  },
}
export default SweepstakesApi;



// WEBPACK FOOTER //
// ./src/api/sweepstakes.js